/**
 * GNB(헤더 메뉴) 전용 트래킹.
 *
 * 데스크톱 메가메뉴는 hover로 펼쳐지므로 `data-gnb-mega-track` 마커가 붙은
 * 부모 메뉴 li에 대해 pointerover/pointerout 위임으로 open/close 이벤트 발사.
 *
 * 모바일 드로어의 open/close 는 header-drawer.js 컴포넌트가 직접 발사.
 */
(function () {
  'use strict';
  if (!window.GBTrack) { console.warn('[GBTrack:gnb] core not loaded'); return; }

  var openMenus = new WeakSet();

  function getProps(el) {
    return {
      menu_type: 'desktop_mega',
      parent_menu_name: el.getAttribute('data-gnb-menu-name') || '',
      parent_menu_name_en: el.getAttribute('data-gnb-menu-name-en') || ''
    };
  }

  // pointerover bubbles → 위임 가능. relatedTarget이 동일 li 내부면 무시 (li 안에서 마우스 이동).
  document.addEventListener('pointerover', function (e) {
    var el = e.target.closest && e.target.closest('[data-gnb-mega-track]');
    if (!el) return;
    if (e.relatedTarget && el.contains(e.relatedTarget)) return;
    if (openMenus.has(el)) return;
    openMenus.add(el);
    window.GBTrack.track('gnb_modal_open', getProps(el));
  }, true);

  document.addEventListener('pointerout', function (e) {
    var el = e.target.closest && e.target.closest('[data-gnb-mega-track]');
    if (!el) return;
    if (e.relatedTarget && el.contains(e.relatedTarget)) return;
    if (!openMenus.has(el)) return;
    openMenus.delete(el);
    window.GBTrack.track('gnb_modal_close', getProps(el));
  }, true);
})();
